import React from 'react';
import { Box } from '@mui/material';
import TopicCard from './TopicCard';
// DnD Kit imports
import { DndContext, closestCenter } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function SortableTopicCard({ topic, ...props }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: topic.id });
  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : 1,
        zIndex: isDragging ? 2 : 1,
      }}
    >
      <TopicCard topic={topic} dragHandleProps={{ ...attributes, ...listeners }} {...props} />
    </div>
  );
}

const DraggableTopicList = ({ 
  topics, 
  onUpdate, 
  onDelete, 
  onAddQuestion, 
  onUpdateQuestion, 
  onDeleteQuestion,
  onReorder,
  onReorderQuestions,
  onUpdateQuestionAttempts
}) => {
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = topics.findIndex(t => t.id === active.id);
      const newIndex = topics.findIndex(t => t.id === over.id);
      const newOrder = arrayMove(topics, oldIndex, newIndex);
      if (onReorder) onReorder(newOrder);
    }
  };

  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={topics.map(t => t.id)} strategy={verticalListSortingStrategy}>
        <Box>
          {topics.map((topic) => (
            <SortableTopicCard
              key={topic.id}
              topic={topic}
              onUpdate={onUpdate}
              onDelete={onDelete}
              onAddQuestion={onAddQuestion}
              onUpdateQuestion={onUpdateQuestion}
              onDeleteQuestion={onDeleteQuestion}
              onReorderQuestions={onReorderQuestions}
              onUpdateQuestionAttempts={onUpdateQuestionAttempts}
            />
          ))}
        </Box>
      </SortableContext>
    </DndContext>
  );
};

export default DraggableTopicList; 